import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import type { UniformTypes } from "~enums/uniformTypes.ts";
import type { SelectBaseSingleProperties } from "~types/selectBaseSingleProperties.ts";
import type { UniformResponse } from "~types/uniform.ts";
import { InfinitySelect, type InfinitySelectOption } from "../InfinitySelect/InfinitySelect";

type Props = SelectBaseSingleProperties<InfinitySelectOption> & {
  baseId: string;
  uniformType: UniformTypes;
};

export const SelectUniform = ({ value, baseId, uniformType, ...props }: Props) => {
  const { sport, organizationId } = useParams();

  const onConvertResponseIntoOptionsHandler = (response: UniformResponse) =>
    (response?.data || []).map((x) => ({ label: x.nameLocal, value: x.uniformId }));

  const filterParameters = { baseType: uniformType, baseId: baseId };

  return (
    <InfinitySelect<UniformResponse>
      {...props}
      url={`${sport}/o/${organizationId}/uniforms`}
      sortByFieldName="nameLocal"
      filterParameters={filterParameters}
      values={isEmpty(value) ? [] : [value]}
      onConvertResponseIntoOptions={onConvertResponseIntoOptionsHandler}
      permissionName={PermissionNames.UNIFORM}
      permissionOperation={PermissionOperations.READ}
    />
  );
};
